module.exports = __webpack_public_path__ + "assets/favicon-512.png";


//////////////////
// WEBPACK FOOTER
// ./images/favicon-512.png
// module id = 156
// module chunks = 0